/* !
 * newsList.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {

	// 研究開発TOP、サステナビリティTOP のニュース取得
	let thisMap = FUNCTIONS.va.isEnglish ? location.pathname.split('/')[2] : location.pathname.split('/')[1];
	if (thisMap === 'rd') {
		thisMap = 'r_and_d';
	}

	const setNewsList = () => {
		const jsonURL = `/ajax${(FUNCTIONS.va.isEnglish) ? '/english' : ''}/news/tag/${thisMap}/list.json`;
		console.log(jsonURL);

		fetch(jsonURL).then(response => response.json()).then(data => {
			if (data.rt_bn_news_list.length) {

				Vue.createApp({
					data() {
						return {
							jsonData: data.rt_bn_news_list,
							count: 5
						}
					},
					methods: {
						setBr(content) {
							return content.replace(/\r?\n/g, '<br>');
						},
						setAttachment(item) {
							if (item.rt_cf_n_href.class && item.rt_cf_n_href.class === 'rt_cf_nolink') {
								return 'nolink';
							} else if (item.rt_cf_n_href.href.endsWith('.pdf')) {
								return 'pdf';
							} else if (FUNCTIONS.va.newsFileType.some(type => item.rt_cf_n_href.href.endsWith(type))) {
								return 'file';
							} else if (item.rt_cf_n_type3_ext_link_is !== null) {
								return 'blank';
							} else {
								return 'link';
							}
						},
						setTarget(att) {
							if (att === 'link') {
								return '_self';
							} else {
								return '_blank';
							}
						},
						setFilesize(bytes) {
							let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
							if (bytes === 0) {
								return 'n/a';
							}
							let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
							if (i === 0) {
								return bytes + sizes[i];
							}
							return (bytes / Math.pow(1024, i)).toFixed(1) + sizes[i];
						}
					},
					computed: {
						filterItems() {
							let items = this.jsonData;
							let itemsTemp = []
							let count = this.count;
							if (count > items.length) { count = items.length; }

							for (let i = 0; i < count; i++) {
								itemsTemp.push(items[i]);
							}
							items = itemsTemp;

							return (items);
						}
					}
				}).mount('#vue-app');
			} else {
				if (thisMap === 'sustainability') {
					document.querySelector('.sustainability-top-news').remove();
				} else {
					document.querySelector('.rd-top-news').remove();
				}
			}
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const newsListFUNCTIONS = () => {
		setNewsList();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsListFUNCTIONS(); }) : newsListFUNCTIONS();

})(window.FUNCTIONS);
